<app-tdo-progress-spinner *ngIf="isLoading" data-cy="ar-fee-calculation-spinner"></app-tdo-progress-spinner>
<div *ngIf="!isLoading" class="section" style="flex: 1; display: flex; flex-direction: column; height: 100%; max-height: 100%; overflow: hidden;" data-cy="ar-fee-calculation">
  <div class="section-header" data-cy="ar-fee-calculation-header">
    <div class="section-header-title" data-cy="ar-fee-calculation-title">Treatment Fee Calculation - Current Doctor/Provider: {{this.globals.currentProviderDoctorFullName}}</div>
  </div>
  <div class="section-content" style="display: flex; flex-direction: column; flex: 1; overflow: hidden;" data-cy="ar-fee-calculation-content">

    <div style="display: flex; flex-direction: row" class="input-container-height" data-cy="ar-fee-calculation-controls">
      <dx-select-box style="margin-top: 3px;  margin-right: 3px;"
        [dataSource]="insuranceOrganizations"
        valueExpr="InsuranceID"
        displayExpr="Description"
        [(value)]="selectedInsuranceID"
        (onValueChanged)="onValueChanged_insuranceOrganizations($event)"
        width="300"
        label="Insurance Carrier Profile"
        labelMode="floating"
        data-cy="ar-fee-calculation-insurance-select"
      ></dx-select-box>



    <dx-drop-down-box width="400"  style="margin-top: 3px;" #fsdropdown
      [(value)]="treeBoxValue"
                      [disabled]="feeVariables?.ARisEstimating"
                      valueExpr="ObjID"
      displayExpr="name"
      label="Fee Schedule"
      labelMode="floating"
      [dataSource]="listOfFeeScedules"
      (onValueChanged)="syncTreeViewSelection()"
      (onOptionChanged)="onTreeBoxOptionChanged($event)"
      (onOpened) = "onTreeViewonContentReady($event)"
      data-cy="ar-fee-calculation-fee-schedule-dropdown"
    >

      <div *dxTemplate="let data of 'content'" data-cy="ar-fee-calculation-fee-schedule-template">
        <dx-tree-view
          [dataSource]="listOfFeeScedules"
          dataStructure="plain"
          keyExpr="ObjID"
          parentIdExpr="ParentID"
          selectionMode="single"
          displayExpr="name"
          [selectByClick]="true"
          (onContentReady)="onTreeViewonContentReady($event)"
          (onItemSelectionChanged)="treeView_itemSelectionChanged($event)"
          (onItemClick)="onTreeItemClick($event)"
          data-cy="ar-fee-calculation-fee-schedule-tree"
        >
        </dx-tree-view>
      </div>



    </dx-drop-down-box>


      <dx-button *ngIf="feeVariables?.ARisEstimating"
        stylingMode="text"
        type="default"
                 icon="help"
                 [hint]="'Why disabled?'"
        (onClick)="onClickHelpEtimate()"
        data-cy="ar-fee-calculation-help-button"
      >

      </dx-button>

    </div>


  <div class="transaction-list-container" style="display: flex; flex-direction: column; height: 100%;" data-cy="ar-fee-calculation-transaction-container">
    <!--    new fees component-->
    <app-ar-fees-list
      [dataTransactionItems]="this.dataTransactionItems"
      [PatientId]="this.PatientId"
      [activeDoctorFeeSchedule]="this.activeDoctorFeeSchedule"
      [activeOrganization]="this.selectedOrganization"
      [postedTransactionItems]="this.postedTransactionItems"
      [showPostedTransactions]="this.showPostedTransactions"
      (showPostedChange)="this.showPostedChange($event)"
      [locations]="this.locations"
      [doctorsByTDOCID]="this.doctorsByTDOCID"
      style="height:100%"
      (itemSelected)="arFeeSelected($event)"
      [ARisEstimating]="feeVariables?.ARisEstimating"
      data-cy="ar-fee-calculation-fees-list"
    >
    </app-ar-fees-list>

  </div>



  <div style="display: flex; flex-direction: column; height: 120px" *ngIf="showPostedTransactions" data-cy="ar-fee-calculation-posted-container">

<!--    commented for testing new fee component-->
      <div style="flex: 1; overflow-y: auto; height: 120px; margin-top: 2px;" data-cy="ar-fee-calculation-posted-table-container">
        <tdo-table [dataSource]="postedTransactionItems" [isMultiSelection]="false" [isSearchable]="false" [isUsePaginator]="false" [isStickyHeader]="true"  (rowSelected)="onPostedTransactionSelected($event)" data-cy="ar-fee-calculation-posted-table">
          <tdo-table-column displayName="Tooth" propertyName="TeethReference" [rowTemplate]="tooth" data-cy="ar-fee-calculation-posted-column-tooth">
            <ng-template #tooth let-row>
              <span data-cy="ar-fee-calculation-posted-tooth">{{ row.model.TeethReference || 'No Tooth Chosen' }}</span>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Procedure" propertyName="Code" [rowTemplate]="procedure" data-cy="ar-fee-calculation-posted-column-procedure">
            <ng-template #procedure let-row>
              <span data-cy="ar-fee-calculation-posted-procedure">{{ row.model.Code + ' ' + row.model.Description }}</span>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Fee" propertyName="PriceAdjusted" [rowTemplate]="fee" data-cy="ar-fee-calculation-posted-column-fee">
            <ng-template #fee let-row>
              <span data-cy="ar-fee-calculation-posted-fee">{{ row.model.Price | currency }}</span> <!--was pulling dataARLedger.Amount, pulling transactionitem.Price-->
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Posted" propertyName="PostDate" [rowTemplate]="posted" data-cy="ar-fee-calculation-posted-column-posted">
            <ng-template #posted let-row>
              <span data-cy="ar-fee-calculation-posted-date">{{ row.model.PostDate | date }}</span>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Location" propertyName="Location" [rowTemplate]="location" data-cy="ar-fee-calculation-posted-column-location">
            <ng-template #location let-row>
              <span data-cy="ar-fee-calculation-posted-location">{{ row.model.Location }}</span>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Origin" propertyName="OriginType" [rowTemplate]="origin" data-cy="ar-fee-calculation-posted-column-origin">
            <ng-template #origin let-row>
              <span data-cy="ar-fee-calculation-posted-origin">{{ row.model.OriginType }}</span>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Doctor" propertyName="DoctorName" [rowTemplate]="doctor" data-cy="ar-fee-calculation-posted-column-doctor">
            <ng-template #doctor let-row>
              <span data-cy="ar-fee-calculation-posted-doctor">{{ row.model.DoctorName }}</span>
            </ng-template>
          </tdo-table-column>
        </tdo-table>
      </div>

  </div>
</div>
